/* eslint-disable import/first */
import React from 'react';
import Skeleton from 'react-loading-skeleton';
import css from './index.module.scss';

export default function HomeSkeleton({isShowHeader}) {
  const renderListItem = (type, count) => {
    return <Skeleton count={1} className={[css.listItem, css[type]].join(' ')} />;
  };
  const renderList = (type, count, hideTitle) => {
    return (
      <div className={[css.listContainer, css[type + 'ListContainer']].join(' ')}>
        {!hideTitle && (
          <Skeleton
            count={1}
            className={[css.mb3, css.radius1, css[type + '-title']].join(' ')}
            width={200}
            height={25}
          />
        )}
        <div className={css.list}>
          {[...Array(count)].map((index) => {
            return renderListItem(type, count);
          })}
        </div>
      </div>
    );
  };
  return (
    <div className={css.root}>
      {isShowHeader && (
         <Skeleton count={1} className={[css.listItem, css.headerItem].join(' ')} />
      )}
      <Skeleton count={1} className={css.heroBanner} />
      {renderList('exclusive', 5)}
      {renderList('explore', 5)}
      {renderList('bestseller', 5)}
      {renderList('deals', 5)}
      {renderList('banner', 2, true)}
      {renderList('banner', 2, true)}
      {renderList('explore', 5)}
    </div>
  );
}
